//更改用户状态信息
export const userStatus = (state,user) => {
  if (user){
    state.userName = user;
    // state.isLogin = true;
  } else if (user == ""){
    //登出的时候，清空sessionStorage里的东西
    sessionStorage.setItem("userName","");
    sessionStorage.setItem("token","");
    state.userName = "";
    // state.token = "";
    // state.isLogin = false;
  }
}

export const userToken = (state,userToken) => {
	if (userToken) {
		state.token = userToken;
	} else {
		state.token = null;
	}
}
export default {
	// actione里设置请求失败的提示
	setToast(state,data){
		console.log("show info msg:", data);
		state.toast.type = data.type;
		state.toast.content = data.info;
		state.toast.count = state.toast.count + 1;
	},
}
